import { Configuration, PopupRequest, PublicClientApplication } from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AAD_CLIENT_ID ?? '',
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AAD_TENANT_ID ?? 'common'}`,
    redirectUri: import.meta.env.VITE_REDIRECT_URI ?? window.location.origin,
  },
  cache: {
    // localStorage sobrevive mejor el ciclo de redirect que sessionStorage.
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

// Instancia MSAL ÚNICA de toda la app (AuthProvider + client.ts la comparten).
// Crear una nueva por llamada rompe: no ve la sesión cacheada -> token vacío -> 401.
export const msalInstance = new PublicClientApplication(msalConfig);

const API_SCOPE = import.meta.env.VITE_API_SCOPE ?? 'api://pmp-pulse/.default';

export const apiScopes: string[] = [API_SCOPE];

// Incluye el scope de la API en el login → el consent se otorga de una vez, así
// acquireTokenSilent(apiScopes) en la primera llamada NO requiere interacción
// (si no, getToken devolvería '' y la primera llamada al API daría 401).
export const loginRequest: PopupRequest = {
  scopes: ['openid', 'profile', 'email', 'User.Read', API_SCOPE],
};
